"use client";
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    UserX: function() {
        return UserX;
    },
    default: function() {
        return _default;
    }
});
const _jsxruntime = require("react/jsx-runtime");
const _utils = require("@mui/material/utils");
const UserX = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxruntime.jsx)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M12 3C10.3431 3 9 4.34315 9 6C9 7.65685 10.3431 9 12 9C13.6569 9 15 7.65685 15 6C15 4.34315 13.6569 3 12 3ZM7 6C7 3.23858 9.23858 1 12 1C14.7614 1 17 3.23858 17 6C17 8.76142 14.7614 11 12 11C9.23858 11 7 8.76142 7 6ZM4.06189 21C4.55399 17.0537 7.92038 14 12 14C12.9449 14 13.8495 14.1634 14.6884 14.4626C15.2086 14.6482 15.7807 14.3769 15.9663 13.8568C16.1518 13.3366 15.8805 12.7645 15.3604 12.5789C14.3088 12.2038 13.1771 12 12 12C6.47715 12 2 16.4772 2 22C2 22.5523 2.44772 23 3 23H13C13.5523 23 14 22.5523 14 22C14 21.4477 13.5523 21 13 21H4.06189ZM16.2929 17.7071C15.9024 17.3166 15.9024 16.6834 16.2929 16.2929C16.6834 15.9024 17.3166 15.9024 17.7071 16.2929L19.5 18.0858L21.2929 16.2929C21.6834 15.9024 22.3166 15.9024 22.7071 16.2929C23.0976 16.6834 23.0976 17.3166 22.7071 17.7071L20.9142 19.5L22.7071 21.2929C23.0976 21.6834 23.0976 22.3166 22.7071 22.7071C22.3166 23.0976 21.6834 23.0976 21.2929 22.7071L19.5 20.9142L17.7071 22.7071C17.3166 23.0976 16.6834 23.0976 16.2929 22.7071C15.9024 22.3166 15.9024 21.6834 16.2929 21.2929L18.0858 19.5L16.2929 17.7071Z",
        fill: "currentColor"
    })
}), "UserX");
const _default = UserX;
